import { Box as ChakraBox } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type BoxProps = ComponentPropsWithRef<typeof ChakraBox>;

export function Box(props: BoxProps) {
  return <ChakraBox {...props} />;
}
